<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content style="max-width: 300px;">
    <div>{{message}}</div>
    <button mat-raised-button (click)="okButtonClicked()" style="margin: 20px;">OK</button>
</div>
